var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.s.container }, [
    _c("div", { style: _vm.s.wrapper }, [
      _c("div", { style: _vm.s.title }, [
        _vm._v(_vm._s(_vm.Title)),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ShowClose,
              expression: "ShowClose"
            }
          ],
          style: _vm.s.close,
          on: { click: _vm.close }
        })
      ]),
      _c(
        "div",
        { style: _vm.s.body },
        [
          _c("span", { staticClass: "bg-img" }),
          _vm.inviteCode
            ? _c("div", [
                _c("div", { staticClass: "invite-code" }, [
                  _vm._v(
                    _vm._s(_vm.$t("assets.invite.myCode")) +
                      _vm._s(this.inviteCode)
                  ),
                  _c("img", {
                    staticClass: "copy-share __pointer",
                    attrs: { src: require("assets/imgs/share.svg") },
                    on: {
                      click: function($event) {
                        return _vm.copyShare()
                      }
                    }
                  }),
                  _c("img", {
                    staticClass: "copy __pointer",
                    attrs: { src: require("assets/imgs/copy_default.svg") },
                    on: { click: _vm.copy }
                  })
                ]),
                _c("div", { staticClass: "invite-info" }, [
                  _c("div", { staticClass: "item" }, [
                    _c("img", {
                      staticClass: "left",
                      attrs: { src: require("assets/imgs/invite_num.png") }
                    }),
                    _c("div", { staticClass: "right" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("assets.invite.inviteNum")))
                      ]),
                      _c("div", { staticClass: "content" }, [
                        _vm._v(
                          _vm._s(
                            (_vm.inviteInfo && _vm.inviteInfo.inviteCount) || 0
                          )
                        )
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "item" }, [
                    _c("img", {
                      staticClass: "left",
                      attrs: { src: require("assets/imgs/invite_benifit.png") }
                    }),
                    _c("div", { staticClass: "right" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("assets.invite.inviteBenifit")))
                      ]),
                      _c("div", { staticClass: "content" }, [
                        _vm._v(
                          _vm._s(
                            _vm.inviteInfo && _vm.inviteInfo.miningTotal
                              ? _vm.formatNum(_vm.inviteInfo.miningTotal)
                              : 0
                          )
                        )
                      ])
                    ])
                  ])
                ])
              ])
            : _c("div", { staticClass: "__row" }, [
                _c("div", { staticClass: "__row_t" }, [
                  _vm._v(_vm._s(_vm.$t("assets.invite.cost"))),
                  this.avaliableExAmount &&
                  Number(this.avaliableExAmount) >= 1000
                    ? _c("div", { staticClass: "__row_hint" }, [
                        _vm._v(
                          _vm._s(_vm.$t("assets.invite.avaliable")) +
                            " " +
                            _vm._s((_vm.avaliableExAmount || 0) + "dSLS")
                        )
                      ])
                    : _c("div", { staticClass: "__err" }, [
                        _vm._v(_vm._s(_vm.$t("assets.invite.notEnough")))
                      ])
                ]),
                _c("div", { staticClass: "__input_row __unuse_input" }, [
                  _vm._v("1000 dSLS")
                ])
              ]),
          _c("div", { staticClass: "__row __row_t" }, [
            _vm._v(_vm._s(_vm.$t("assets.invite.inviteRule")))
          ]),
          _vm._l(_vm.$t("assets.invite.ruleItems"), function(i, j) {
            return _c("div", { staticClass: "__hint" }, [
              _c("span", { domProps: { innerHTML: _vm._s(i) } })
            ])
          })
        ],
        2
      ),
      _vm.ShowBottom
        ? _c("div", { style: _vm.s.btnGroup }, [
            !!_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.STxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  { style: [_vm.s.lBtn, _vm.s.btn], on: { click: _vm.lClick } },
                  [_vm._v(_vm._s(_vm.LTxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.RTxt))]
                )
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }